import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from 'src/app/models/AccountModel';
import { UserListComponent } from '../admin/user-list.component';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { SettingsWizardComponent } from '../settings-wizard/settings-wizard-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-user-dashboard',
  templateUrl: './admin-user-dashboard.component.html',
  styleUrls: ['./admin-user-dashboard.component.scss']
})
export class AdminUserDashboardComponent implements OnInit {
  selectedUser: User;

  @ViewChild(UserListComponent) userList: UserListComponent;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService, public dialog: MatDialog) { }

  ngOnInit() {
  }

  showAllUsers() {
    this.selectedUser = undefined;
  }

  onStateChange(event) {
    let dialogRef;

    switch(event.state) {
      case 'CREATE':
        break;
      case 'SELECT':
      case 'EDIT':
        this._platformApi.getAccount(event.item.accountId).subscribe(account => {
          dialogRef = this.dialog.open(SettingsWizardComponent, {
            panelClass: 'flush-dialog',
            disableClose: true,
            autoFocus: false,
            data: {
              selectedAccount: account,
              startingMenuItem: 'ACCOUNT_USERS_START'
            }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.userList.refresh();
          });
        })

        break;
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.selectedUser = undefined;
        break;
    }
  }
}
